import { ComponentsOverrides, Theme } from "@mui/material";

type MuiInputAdornment = {
  styleOverrides: ComponentsOverrides<Theme>["MuiInputAdornment"];
};

const muiInputAdornment: MuiInputAdornment = {
  styleOverrides: {
    root: {
      "&&.MuiInputAdornment-root:not(.MuiInput-hiddenLabel)": {
        marginTop: 0,
      },
    },
  },
};

export default muiInputAdornment;
